export default "__VITE_ASSET__94fa0382__"